const PRODUCT_FORMATS = new Set(['EAN_13', 'EAN_8', 'UPC_A', 'UPC_E']);

/**
 * What a scanned code is, so a box label with several codes on it gives the
 * product barcode rather than the serial number or a website QR.
 *   label   → our own QR label
 *   product → retail barcode (EAN / UPC)
 *   link    → web address, says nothing about the product
 *   other   → anything else: serial number, lot, material or shop code
 */
export function classifyScan(text, format) {
  const value = String(text || '').trim();
  if (/^PAYDAAI:/i.test(value)) return 'label';
  if (/^[a-z][a-z0-9+.-]*:\/\//i.test(value)) return 'link';
  return PRODUCT_FORMATS.has(format) ? 'product' : 'other';
}

/** True for EAN-8, UPC-A and EAN-13 numbers with a correct check digit. */
export function isProductBarcode(value) {
  const code = String(value || '');
  if (!/^(\d{8}|\d{12}|\d{13})$/.test(code)) return false;
  const digits = [...code].map(Number);
  const check = digits.pop();
  const total = digits.reverse().reduce((sum, d, i) => sum + d * (i % 2 === 0 ? 3 : 1), 0);
  return (10 - (total % 10)) % 10 === check;
}

/** Serial numbers usually mix letters and digits; material codes are digits only. */
export function isSerialCandidate(text) {
  return /[a-z]/i.test(String(text || ''));
}
